

import kr from '../../kr/kr';

export default class AtractionMap extends kr.Component {
    init()
    {
        this.map = null;
        this.lat = this.$element.getAttribute('data-lat');
        this.lng = this.$element.getAttribute('data-lng');
        this.html = this.$element.innerHTML;

        if (!this.lat || !this.lng) {
            return false;
        }

        this.app.addJs('https://unpkg.com/leaflet@1.7.1/dist/leaflet.js', true, this._callback.bind(this));
        this.app.addCss('https://unpkg.com/leaflet@1.7.1/dist/leaflet.css');
    }

    bind()
    {
        this.map = window.L.map(this.$element, {
            center: [this.lat, this.lng],
            zoom: 11
        });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(this.map);

        const marker = L.marker([this.lat, this.lng]).addTo(this.map);
        marker.bindPopup(this.html);
    }

    _callback()
    {
        this.bind();
    }

}

kr.registerComponent('.js-map', {
    component: AtractionMap
});
